export function getLastValueInMap(map: Map<any, any>) {
  return Array.from(map.values())[map.size - 1];
}
